<div class="modal show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <i
          *ngIf="close$.observers.length"
          class="fal fa-times pointer"
          (click)="close()"
        ></i>
      </div>
      <div class="modal-body"><ng-content></ng-content></div>
      <div class="modal-footer">
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop show" (click)="close()"></div>
